<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>

  </div>
  <mat-sidenav-container class="particle-page-content-container m-t-25 m-l-25">
    <div class="container flex flex-col justify-start items-start">
      <div class="company-select-wrapper">
        <mat-form-field appearance="outline" class="no-mat-label">
          <mat-label>Company(ies):</mat-label>
          <mat-select [(value)]="companyId" placeholder="Companies" (selectionChange)="onSelectionChange($event)">
            <mat-option *ngFor="let company of companyList"
                        [value]="company.companyId">{{company.companyName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="subscription flex flex-col justify-start items-start">
        <label class="m-b-10"> <strong>Subscription Id</strong></label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="Subscription Id" [(ngModel)]="dataFactorySubscription.subscriptionId"/>
        </mat-form-field>
      </div>
      <div class="resource-group flex flex-col justify-start items-start">
        <label class="m-b-10"> <strong>ResourceGroup Id</strong></label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="ResourceGroup Id" [(ngModel)]="dataFactorySubscription.resourceGroupId"/>
        </mat-form-field>
      </div>
      <div class="data-factory flex flex-col justify-start items-start">
        <label class="m-b-10"> <strong>DataFactory Id</strong></label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="DataFactory Id" [(ngModel)]="dataFactorySubscription.dataFactoryId"/>
        </mat-form-field>
      </div>
      <div class="pipelineContainer" *ngIf="dataFactoryPipelines!=null && dataFactoryPipelines.length>0">
        Pipeline(s)
        <div class="pipelines p-t-10">
          <div *ngFor="let pipeline of dataFactoryPipelines">
            <mat-checkbox [(ngModel)]="pipeline.isActive">
              {{pipeline.displayName}}
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div class="footer-section p-t-10 flex flex-row justify-between items-start">
        <button mat-button class="action-button" [disabled]="!isValid" (click)="submit()">
          Submit
        </button>
      </div>
    </div>

  </mat-sidenav-container>
</div>
